import { getStorageItem } from 'utils/browserCache';
import { LOCAL_STORAGE_KEY, STORAGE_LOCATION } from 'constants/browserCache';
import { AuthenticationStateType } from 'hooks/authentication/types';
import { ConversationStateType } from 'hooks/conversation/types';
import { InitLog } from '../types';

/**
 * Define initial schema then progressively set metric values during initialization.
 * Only considers success case (with retries if necessary). Not error case.
 * NOTE: DataDog parses payload as JSON. Must use 'null' primitive data type instead of 'undefined'
 * @param authenticationState
 * @param conversationState
 * @returns init metrics object
 */
export const getInitLoggerObj = (
  authenticationState: AuthenticationStateType,
  conversationState: ConversationStateType,
): InitLog => {
  const wasInitViewOpen =
    getStorageItem(STORAGE_LOCATION.SESSION_STORAGE, LOCAL_STORAGE_KEY.CHAT_INITIALIZE_VIEW)
      ?.wasInitOpen || false;

  return {
    conversationMessageCount: null,
    isCachedAuthValid: null,
    isExistingConversation: conversationState.isExistingConversation,
    timestampCurrInit: Date.now(),
    timestampLastInit: authenticationState.unixTimeLastInitialization || null,
    wasInactivityTimeout: conversationState.isInactivityTimeout,
    wasInitViewOpen,
    msElapsed: {
      twilioGetMessages: null,
      twilioInit: null,
      questionSend: null,
      loadingTotal: null,
      startConversation: null,
      putContext: null,
    },
    retries: {
      startConversation: null,
      putContext: null,
      twilio: null,
    },
  };
};
